<form class="pre-form" #formulari="ngForm">        
    <p i18n>Estudis de grau, llicenciatura o equivalent</p>
    <mat-grid-list [cols]="nombreColumnes()" rows="3" rowHeight="80px">                              
      <mat-grid-tile>
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-pais" placeholder="País on esteu cursant l'estudi" 
                  [matAutocomplete]="auto" [formControl]="paisCtrl" [ngModel]="trasllat.estudiRealitzat.pais" required (ngModelChange)="paisChange($event)" i18n-placeholder="@@e70de1ad8cadd4d358382f5524801308c2727ce7">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="utilitats.displayName">
                  <mat-option *ngFor="let x of filteredPaisos | async" [value]="x">                                        
                      {{ x?.name }}
                  </mat-option>
              </mat-autocomplete>
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="trasllat.estudiRealitzat.paisEspanya()">
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-universitat" placeholder="Universitat" 
                  [matAutocomplete]="universitat" [formControl]="universitatCtrl"  [ngModel]="trasllat.estudiRealitzat.universitat" required (ngModelChange)="universitatChange($event)" i18n-placeholder>
              <mat-autocomplete #universitat="matAutocomplete" [displayWith]="utilitats.displayName">
                      <mat-option *ngFor="let x of filteredUniversitats | async" [value]="x">                                        
                          {{ x?.name }}
                      </mat-option>
              </mat-autocomplete>                                
          </mat-form-field>                            
      </mat-grid-tile>
      <mat-grid-tile *ngIf="!trasllat.estudiRealitzat.paisEspanya()">
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-universitat-text" placeholder="Universitat" [(ngModel)]="trasllat.estudiRealitzat.universitatText" required i18n-placeholder>
          </mat-form-field>                            
      </mat-grid-tile>                    
      <mat-grid-tile *ngIf="trasllat.estudiRealitzat.paisEspanya()">
          <mat-form-field class="pre-field">
              <input matInput name="estudi-realitzat-estudi" placeholder="Estudis" 
                  [matAutocomplete]="estudi" [formControl]="estudisCtrl" [ngModel]="trasllat.estudiRealitzat.estudi" required (ngModelChange)="estudiChange($event)" i18n-placeholder>
              <mat-autocomplete #estudi="matAutocomplete" [displayWith]="utilitats.displayName">
                      <mat-option *ngFor="let x of filteredEstudis | async" [value]="x">                                        
                          {{ x?.name }}
                      </mat-option>
              </mat-autocomplete>                                
          </mat-form-field>                            
      </mat-grid-tile>   
      <mat-grid-tile *ngIf="!trasllat.estudiRealitzat.paisEspanya()">
              <mat-form-field class="pre-field">
                  <input matInput  name="estudi-realitzat-estudi-text" placeholder="Estudis" [(ngModel)]="trasllat.estudiRealitzat.estudiText" required i18n-placeholder>
              </mat-form-field>                            
    </mat-grid-tile>     

    <mat-grid-tile [colspan]="nombreColumnes()">        
            <mat-checkbox name="swAssabentatIdioma" [(ngModel)]="trasllat.estudiRealitzat.swAssabentatIdioma" i18n="@@SwAssabentatIdioma">Declaro que estic assabentat/da de la llengua o les llengües d’impartició de l’estudi al qual vull accedir i al mateix temps renuncio a presentar cap mena de reclamació ni exigència en relació a la llengua o les llengües que s’imparteixi la docència de l’estudi.</mat-checkbox>                              
    </mat-grid-tile>                                                        
    <mat-grid-tile [colspan]="nombreColumnes()" *ngIf="trasllat.potModificar">
          <div class="pre-controls-right">
              <button mat-raised-button matStepperPrevious i18n>Torna</button>
              <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
          </div>
    </mat-grid-tile>
  </mat-grid-list>
</form> 


// WEBPACK FOOTER //
// ./src/app/estudis/estudis.component.html